import * as FileUploadConstants from './FileUploadConstants';
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');

// The initial application state
const initialState = {};

export default function FileUploadReducer(state = initialState, action) {

    switch (action.type) {
        case FileUploadConstants.FILE_UPLOAD_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isDefPathsFetching: false,
                    isDefPathsFetched: false,
                    isDefPathFetchFailed: false,
                    defaultPathList: [],
                    isDirListFetching: false,
                    isDirListFetched: false,
                    isDirListFetchFailed: false,
                    dirList: [],
                    dirListSkip: FileUploadConstants.INITIAL_DIR_LISTING_SKIP,
                    dirListTake: FileUploadConstants.INITIAL_DIR_LISTING_TAKE,
                    dirListHasNext: false,
                    absolutePath: '',
                    initPath:'',
                    initDisplayPath:'',
                    innerPath: [],
                    isDirListSuccessull: false,
                    isProServiceModel: false,
                    isFolderUploadSupported: false,
                    dirListFailureMsg: '',
                    displayDirListErrModal: false,
                    isDeviceFilesFetching: false,
                    isDeviceFilesFetchFailed: false,
                    deviceFilesSubscribers: [],
                    errorMessage: ""
                }
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DEF_PATH_FETCH_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isDefPathsFetching: true,
                    isDefPathsFetched: false,
                    isDefPathFetchFailed: false,
                    defaultPathList: [],
                    isDirListFetching: false,
                    isDirListFetched: false,
                    isDirListFetchFailed: false,
                    dirList: [],
                    absolutePath: '',
                    errorMessage: ""
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DEF_PATH_FETCH_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDefPathsFetching: false,
                    isDefPathsFetched: true,
                    isDefPathFetchFailed: false,
                    defaultPathList: action.payload.newState.result
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DEF_PATH_FETCH_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDefPathsFetching: false,
                    isDefPathsFetched: true,
                    isDefPathFetchFailed: true,
                    errorMessage: action.payload.errorMessage
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DIR_LIST_FETCH_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDirListFetching: true,
                    isDirListFetched: false,
                    isDirListFetchFailed: false,
                    dirList: action.payload.addToList ? [...state[action.payload.instanceId].dirList] : [],
                    dirListSkip: action.payload.dirListSkip,
                    dirListTake: action.payload.dirListTake,
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DIR_LIST_FETCH_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDirListFetched: true,
                    isDirListFetching: false,
                    isDirListFetchFailed: false,
                    isDirListSuccessull: action.payload.newState.IsSuccessful,
                    isProServiceModel: action.payload.newState.isProServiceModel,
                    isFolderUploadSupported: action.payload.newState.isFolderUploadSupported,
                    dirListFailureMsg: action.payload.newState.FailureMessage,
                    dirList: [...state[action.payload.instanceId].dirList, ...action.payload.newState.Entries],
                    dirListHasNext: action.payload.newState.HasNext
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_DIR_LIST_FETCH_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDirListFetching: false,
                    isDirListFetched: true,
                    isDirListFetchFailed: true,
                    displayDirListErrModal: true,
                    dirListHasNext: false
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FETCH_FILES_FROM_DEVICE_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isDeviceFilesFetching: true,
                    isDeviceFilesFetchFailed: false,
                    deviceFilesSubscribers: []
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FETCH_FILES_FROM_DEVICE_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDeviceFilesFetching: false,
                    isDeviceFilesFetchFailed: false,
                    deviceFilesSubscribers: [...action.payload.newItem]
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FETCH_FILES_FROM_DEVICE_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDeviceFilesFetching: false,
                    isDeviceFilesFetchFailed: true,
                    deviceFilesSubscribers: []
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_SET_ABS_PATH: {
            let initPath = state[action.payload.instanceId].initPath;
            let initDisplayPath = state[action.payload.instanceId].initDisplayPath;
            let innerPath = [];
            if(action.payload.isDefaultPath){
                initPath = action.payload.absPath;
                initDisplayPath = action.payload.logicalPath;
            }else{
                innerPath =[...state[action.payload.instanceId].innerPath, action.payload.newPath]
            }

            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    absolutePath: action.payload.absPath,
                    initPath: initPath,
                    initDisplayPath,
                    innerPath: innerPath
                };
            });

            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_UPDATE_ABS_PATH: {
            let innerPath = [...state[action.payload.instanceId].innerPath];
            let indexOfPath = action.payload.newItem.index;
            innerPath.length = indexOfPath+1;

            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    absolutePath: action.payload.newItem.path,
                    innerPath: innerPath    
                };
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FETCH_FILES_FROM_DEVICE_ON_BTN_CLICKED: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDeviceFilesFetching: false
                }
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.DIR_LIST_ERR_MODAL_CONTROL: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    displayDirListErrModal: action.payload.displayDirListErrModal
                }
            });
            return assign({}, state, newState);
        }
        case FileUploadConstants.FILE_UPLOAD_RESET_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDeviceFilesFetchFailed: false
                }
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}